module.exports = __webpack_public_path__ + "static/media/x-icon-black.55ff431a.svg";